import { Box, Button, ButtonGroup, useTheme } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import UserContext from '../../../shared-components/contexts/UserContext';
import CookieService from '../../../shared-services/CookieService';

interface IPageControls {
  showInNetworkOnly: boolean | undefined;
  setShowInNetworkOnly: (value: boolean | undefined) => void;
}

const PageControls = (props: IPageControls) => {
  const NETWORKTOGGLE_COOKIE_NAME = 'Home_NetworkToggle';

  const user = useContext(UserContext);
  const theme = useTheme();

  const [filtersLoaded, setFiltersLoaded] = React.useState(false);

  useEffect(() => {
    if (user.isGeneralist) {
      const networkToggleCookie = CookieService.Get(NETWORKTOGGLE_COOKIE_NAME);

      props.setShowInNetworkOnly(networkToggleCookie === 'true');
    } else {
      props.setShowInNetworkOnly(false);
    }

    setFiltersLoaded(true);
  }, []);

  useEffect(() => {
    if (filtersLoaded && user.isGeneralist) {
      CookieService.Create(
        NETWORKTOGGLE_COOKIE_NAME,
        String(props.showInNetworkOnly),
        undefined,
        undefined,
        'lax',
      );
    }
  }, [props.showInNetworkOnly]);

  return (
    <Box>
      {user.isGeneralist && (
        <ButtonGroup color="primary">
          <Button
            aria-label="Connected"
            onClick={() => props.setShowInNetworkOnly(true)}
            style={
              props.showInNetworkOnly
                ? {
                    color: '#fff',
                    backgroundColor: theme.palette.primary.main,
                  }
                : {}
            }
          >
            Connected
          </Button>
          <Button
            aria-label="All"
            onClick={() => props.setShowInNetworkOnly(false)}
            style={
              !props.showInNetworkOnly
                ? {
                    color: '#fff',
                    backgroundColor: theme.palette.primary.main,
                  }
                : {}
            }
          >
            All
          </Button>
        </ButtonGroup>
      )}
    </Box>
  );
};

export default PageControls;
